import { Pipe, PipeTransform } from '@angular/core';

import { Policy } from '@amfam/policy/models';

@Pipe({
  name: 'riskcount',
  standalone: false
})
export class RiskCountPipe implements PipeTransform {
  transform(policies: Policy[]): number {
    if (!policies) return 0;
    return policies.reduce((count, policy) => count + policy.policyRisks.length, 0);
  }
}
